import { queueScheduler } from 'rxjs';
export var schedulerNow = function (scheduler) { return (scheduler || queueScheduler).now(); };
//# sourceMappingURL=now.js.map